export interface ILoaiQuyHoach {
  id?: number;
  ten?: string | null;
}

export const defaultValue: Readonly<ILoaiQuyHoach> = {};
